const mediaItems = [
  {
    title: '鬼灭之刃：无限城篇',
    subtitle: '最新话连载中 · 全站热度第一',
    viewers: '128万阅读',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manga%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20Japanese%20clothing%20fighting%20against%20a%20moonlit%20castle%20backdrop%2C%20dynamic%20action%20pose%20with%20water%20breathing%20effects%2C%20vibrant%20turquoise%20and%20crimson%20color%20scheme%2C%20anime%20art%20style%2C%20epic%20composition%2C%20warm%20lighting%20from%20flames&width=600&height=400&seq=media-comic-01&orientation=landscape',
  },
  {
    title: '咒术回战：涉谷事变',
    subtitle: '高能剧情 · 读者评分9.6',
    viewers: '96万阅读',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20urban%20fantasy%20manga%20illustration%20showing%20a%20modern%20city%20street%20at%20night%20with%20supernatural%20energy%20swirling%2C%20a%20figure%20with%20spiky%20hair%20casting%20a%20powerful%20technique%2C%20purple%20and%20black%20energy%20effects%2C%20dramatic%20lighting%2C%20intense%20atmosphere&width=600&height=400&seq=media-comic-02&orientation=landscape',
  },
  {
    title: '海贼王：最终章',
    subtitle: '传奇连载 · 全球同步更新',
    viewers: '156万阅读',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20pirate%20adventure%20manga%20illustration%20with%20a%20grand%20ship%20sailing%20on%20rough%20ocean%20waves%20under%20a%20dramatic%20sunset%20sky%2C%20treasure%20chest%20gleaming%20on%20deck%2C%20adventurous%20spirit%2C%20warm%20golden%20and%20deep%20blue%20colors%2C%20cinematic%20composition&width=600&height=400&seq=media-comic-03&orientation=landscape',
  },
  {
    title: '间谍过家家：第二季',
    subtitle: '温馨家庭喜剧 · 欢乐连载中',
    viewers: '87万阅读',
    image: 'https://readdy.ai/api/search-image?query=A%20charming%20family%20comedy%20manga%20illustration%20of%20a%20family%20of%20three%20having%20dinner%20together%20in%20a%20cozy%20European%20style%20apartment%2C%20warm%20lighting%20from%20chandelier%2C%20playful%20expressions%2C%20soft%20pastel%20colors%2C%20heartwarming%20atmosphere&width=600&height=400&seq=media-comic-04&orientation=landscape',
  },
  {
    title: '葬送的芙莉莲',
    subtitle: '治愈催泪 · 年度口碑神作',
    viewers: '73万阅读',
    image: 'https://readdy.ai/api/search-image?query=A%20melancholic%20fantasy%20manga%20illustration%20of%20an%20elf%20mage%20walking%20through%20a%20flowering%20meadow%20at%20sunset%2C%20long%20flowing%20hair%2C%20gentle%20expression%2C%20distant%20fantasy%20castle%20silhouette%2C%20warm%20golden%20and%20lavender%20tones%2C%20nostalgic%20and%20peaceful%20mood&width=600&height=400&seq=media-comic-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            热门推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            人气飙升的漫画作品，大家都在看
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                    <span className="text-xs text-white/90 bg-black/40 px-2.5 py-1 rounded-full">
                      {item.viewers}
                    </span>
                    <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full cursor-pointer">
                      <i className="ri-play-fill text-white text-lg ml-0.5"></i>
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}